module.exports = __webpack_public_path__ + "img/zurb-color.894df50f.svg";